import { render, staticRenderFns } from "./staticWrapper.vue?vue&type=template&id=03b6ea5e&scoped=true&"
import script from "./staticWrapper.vue?vue&type=script&lang=js&"
export * from "./staticWrapper.vue?vue&type=script&lang=js&"
import style0 from "./staticWrapper.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./staticWrapper.vue?vue&type=style&index=1&id=03b6ea5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6ea5e",
  null
  
)

export default component.exports